export class BlogService {
  constructor() {}

  baseURL() {
    let url_base = 'https://novasector.net/v1/'
    if (process.env.NODE_ENV === 'development')
      url_base = 'http://localhost:4200/v1/'
    return url_base
  }

  authHeaders() {
    const jwt = window.novasectorapp.getJWT()
    return {
      'Content-type': 'application/json; charset=UTF-8',
      'Autorization': 'Token ' + jwt
    }
  }

  jsonHeaders() {
    return { 'Content-type': 'application/json; charset=UTF-8' }
  }

  visitorKey() {
    const keyName = 'novasector-visitor-key'
    let key = localStorage.getItem(keyName)
    if (!key) {
      key = (crypto?.randomUUID?.() ||
        ('vk-' + Date.now() + '-' + Math.random().toString(36).slice(2)))
      localStorage.setItem(keyName, key)
    }
    return key
  }

  async getTopics() {
    const res = await fetch(this.baseURL() + 'topics', { headers: this.jsonHeaders() })
    if (!res.ok) throw new Error('Failed to load topics')
    return res.json()
  }

  async getTopic(slug) {
    const res = await fetch(this.baseURL() + 'topics/' + encodeURIComponent(slug), {
      headers: this.jsonHeaders()
    })
    if (!res.ok) throw new Error('Failed to load topic')
    return res.json()
  }

  async getPost(slug) {
    const res = await fetch(this.baseURL() + 'posts/' + encodeURIComponent(slug), {
      headers: this.jsonHeaders()
    })
    if (!res.ok) throw new Error('Failed to load post')
    return res.json()
  }

  async getCommentToken(postId) {
    const res = await fetch(this.baseURL() + 'posts/' + postId + '/comment_token', {
      headers: this.jsonHeaders()
    })
    if (!res.ok) throw new Error('Failed to prepare comment')
    return res.json()
  }

  async addComment(postId, author_name, body, comment_token, ns_leave_blank) {
    const res = await fetch(this.baseURL() + 'posts/' + postId + '/comments', {
      method: 'POST',
      headers: this.jsonHeaders(),
      body: JSON.stringify({ author_name, body, comment_token, ns_leave_blank })
    })
    return res.json()
  }

  async reactToPost(postId, reaction_type) {
    const res = await fetch(this.baseURL() + 'posts/' + postId + '/reactions', {
      method: 'POST',
      headers: this.jsonHeaders(),
      body: JSON.stringify({
        visitor_key: this.visitorKey(),
        reaction_type
      })
    })
    return res.json()
  }

  async reactToComment(commentId, reaction_type) {
    const res = await fetch(this.baseURL() + 'comments/' + commentId + '/reactions', {
      method: 'POST',
      headers: this.jsonHeaders(),
      body: JSON.stringify({
        visitor_key: this.visitorKey(),
        reaction_type
      })
    })
    return res.json()
  }

  // Admin
  async adminListTopics() {
    const res = await fetch(this.baseURL() + 'admin/topics', {
      headers: this.authHeaders()
    })
    const pkg = await res.json()
    if (pkg.jwt) window.novasectorapp.setJWT(pkg.jwt)
    return pkg
  }

  async adminSaveTopic(topic) {
    const isNew = !topic.id
    const url = isNew
      ? this.baseURL() + 'admin/topics'
      : this.baseURL() + 'admin/topics/' + topic.id
    const res = await fetch(url, {
      method: isNew ? 'POST' : 'PATCH',
      headers: this.authHeaders(),
      body: JSON.stringify({ topic })
    })
    const pkg = await res.json()
    if (pkg.jwt) window.novasectorapp.setJWT(pkg.jwt)
    return pkg
  }

  async adminDeleteTopic(id) {
    const res = await fetch(this.baseURL() + 'admin/topics/' + id, {
      method: 'DELETE',
      headers: this.authHeaders()
    })
    const pkg = await res.json()
    if (pkg.jwt) window.novasectorapp.setJWT(pkg.jwt)
    return pkg
  }

  async adminListPosts() {
    const res = await fetch(this.baseURL() + 'admin/posts', {
      headers: this.authHeaders()
    })
    const pkg = await res.json()
    if (pkg.jwt) window.novasectorapp.setJWT(pkg.jwt)
    return pkg
  }

  async adminSavePost(blog_post) {
    const isNew = !blog_post.id
    const url = isNew
      ? this.baseURL() + 'admin/posts'
      : this.baseURL() + 'admin/posts/' + blog_post.id
    const res = await fetch(url, {
      method: isNew ? 'POST' : 'PATCH',
      headers: this.authHeaders(),
      body: JSON.stringify({ blog_post })
    })
    const pkg = await res.json()
    if (pkg.jwt) window.novasectorapp.setJWT(pkg.jwt)
    return pkg
  }

  async adminUploadImage(file) {
    const data = new FormData()
    data.append("image", file)
    const res = await fetch(this.baseURL() + "admin/blog_images", {
      method: "POST",
      headers: {
        Autorization: "Token " + window.novasectorapp.getJWT()
      },
      body: data
    })
    const pkg = await res.json()
    if (pkg.jwt) window.novasectorapp.setJWT(pkg.jwt)
    return pkg
  }

  async adminDeletePost(id) {
    const res = await fetch(this.baseURL() + 'admin/posts/' + id, {
      method: 'DELETE',
      headers: this.authHeaders()
    })
    const pkg = await res.json()
    if (pkg.jwt) window.novasectorapp.setJWT(pkg.jwt)
    return pkg
  }
}
